// extracted by mini-css-extract-plugin
export default {"entryPoint":"entry-point_entryPoint__p-D6J"};